export default __webpack_public_path__ + "static/media/clients-list.efd035ca.png";